export class CookieService {

    constructor(cookieName) {
        this.cookieName = cookieName;
    }

    /**
     * Sets a cookie
     */
    setCookie(expireDate, value) {
        if (this.cookieExists()) {
            return;
        }

        let expires = expireDate || 60 * 60 * 24 * 365;
        let cookieValue = value || true;

        document.cookie = this.cookieName + "=" + cookieValue + "; max-age=" + expires + "; path=/";
    }

    /**
     * Checks that cookie exists
     */
    cookieExists() {
        return !!this.getCookieValue();
    }

    /**
     * Get cookievalue
     */
    getCookieValue() {
        let cookieValue = document.cookie.match('(^|;) ?' + this.cookieName + '=([^;]*)(;|$)');
        return cookieValue ? cookieValue[2] : null;
    }

    deleteCookie() {
        if (this.cookieExists()) {
            document.cookie = this.cookieName + "=; expires=Thu, 01 Jan 1990 00:00:01 GMT; path=/";
        }
    }

}



// WEBPACK FOOTER //
// ./www/wp-content/themes/lynx-hedge/assets/scripts/src/App/Services/CookieService.js